import { __awaiter, __decorate, __generator } from "tslib";
import { injectable } from 'tsyringe';
import { fetchSiteFeatures } from '@gn-audio/core/api/site-settings/fetch-site-features';
import { getBasketTotalCount } from '../../utilities/get-basket-total-count';
import { BasketEngravingItemComponent, BasketEngravingPopupComponent } from './components';
import { isProductAllowedForEngraving } from './utilities/is-product-allowed-for-engraving';
var BasketEngravingPlugin = /** @class */ (function () {
    function BasketEngravingPlugin() {
        var _this = this;
        this.engravingItems = [];
        this.showEngravingPopup = function (item, callback, engravingUuid) {
            new BasketEngravingPopupComponent()
                .render({
                callback: callback,
                data: item,
                eventBus: _this.eventBus,
                translations: _this.translations,
                engraving3dRenderingUuid: engravingUuid,
            });
        };
        this.reactOnChanges = function (state) { return __awaiter(_this, void 0, void 0, function () {
            var totalCount;
            var _this = this;
            return __generator(this, function (_a) {
                this.engravingItems.length = 0;
                totalCount = getBasketTotalCount(state);
                if (totalCount === 0) {
                    this.engravingItems.forEach(function (x) { x.destroy(); });
                }
                else {
                    state.product_items
                        .forEach(function (productItem) { return __awaiter(_this, void 0, void 0, function () {
                        var isAllowedForEngraving, component;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, isProductAllowedForEngraving(productItem.product_id)];
                                case 1:
                                    isAllowedForEngraving = _a.sent();
                                    if (!isAllowedForEngraving) {
                                        return [2 /*return*/];
                                    }
                                    component = new BasketEngravingItemComponent();
                                    component.render({
                                        container: this.container.querySelector("[data-item-id=\"".concat(productItem.item_id, "\"]")),
                                        data: { product: productItem, service: null, serviceSku: null },
                                        eventBus: this.eventBus,
                                        translations: this.translations,
                                    });
                                    this.engravingItems.push(component);
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                return [2 /*return*/];
            });
        }); };
    }
    BasketEngravingPlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus, state = _a.state, translations = _a.translations;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.translations = translations;
                        this.container = document.querySelector(".basket-ui__content" /* BasketUIElementSelector.BasketContent */);
                        this.eventBus = eventBus;
                        this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
                        this.eventBus.subscribe("show-engraving-popup" /* BasketEvent.ShowEngravingPopup */, this.showEngravingPopup);
                        return [4 /*yield*/, this.reactOnChanges(state)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketEngravingPlugin.prototype.shouldRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var featureToggles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchSiteFeatures(["SfccBasketEngraving" /* SiteFeature.SfccBasketEngraving */])];
                    case 1:
                        featureToggles = _a.sent();
                        return [2 /*return*/, featureToggles.length > 0 && !!featureToggles[0].value];
                }
            });
        });
    };
    BasketEngravingPlugin.prototype.unregister = function () {
        this.eventBus.unsubscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
        this.eventBus.unsubscribe("show-engraving-popup" /* BasketEvent.ShowEngravingPopup */, this.showEngravingPopup);
        this.engravingItems.forEach(function (x) { x.destroy(); });
    };
    BasketEngravingPlugin = __decorate([
        injectable()
    ], BasketEngravingPlugin);
    return BasketEngravingPlugin;
}());
export { BasketEngravingPlugin };
